import { ChangeDetectionStrategy, Component, computed, inject, input, InputSignal, Signal } from '@angular/core';
import { ProductBundleModel, ProductBundleType, ProductPricesModel } from '@libs/shop/models';
import { ProductPriceVisibilityService } from '@libs/shared/ui';
import { ProductBundleItemComponent } from '../../catalog';

@Component({
  selector: 'ui-product-detail-bundle-item-list',
  imports: [
    ProductBundleItemComponent,
  ],
  templateUrl: './product-detail-bundle-item-list.component.html',
  styleUrl: './product-detail-bundle-item-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductDetailBundleItemListComponent {
  public priceVisibilityService: ProductPriceVisibilityService = inject(ProductPriceVisibilityService);
  public bundleType: InputSignal<ProductBundleType> = input.required();
  public bundle: InputSignal<ProductBundleModel> = input.required();
  public bundlePrices: InputSignal<ProductPricesModel | undefined> = input.required();
  public arePricesVisible: Signal<boolean> = computed(() => this.priceVisibilityService.arePricesVisible(this.bundlePrices()));
}
